export enum ImportProductsFieldNames {
  CATEGORY_ID = 'category_id',
  PARTNER_ID = 'partner_id',
  PARTNER_IDS = 'partner_ids',
  IS_CONFIRMED = 'is_confirmed',
  WITH_PHOTOS = 'with_photos',
}

export type TImportProductsForm = {
  [ImportProductsFieldNames.CATEGORY_ID]: string;
  [ImportProductsFieldNames.PARTNER_ID]: string;
  [ImportProductsFieldNames.IS_CONFIRMED]: string;
  [ImportProductsFieldNames.WITH_PHOTOS]: string;
};

export type TGetImportsQuery = {
  [ImportProductsFieldNames.PARTNER_IDS]?: string[];
  limit?: number;
  page?: number;
};

export enum ImportStocksFieldNames {
  CATEGORY_ID = 'category_id',
  PARTNER_ID = 'partner_id',
  FILE = 'file',
}

export type TImportStocksForm = {
  [ImportStocksFieldNames.CATEGORY_ID]: string;
  [ImportStocksFieldNames.PARTNER_ID]: string;
  [ImportStocksFieldNames.FILE]: File;
};
